import { IReferenceValue } from '.';

export enum NorthStarPath {
  ALREADY_AZURE = 'Already Azure',
  REDEPLOY = 'Redeploy',
  REFACTOR = 'Refactor',
  RE_HOST = 'Rehost',
  WILL_NOT_GO_AZURE = 'Will Not Go To Azure',
  REPLATFORM = 'Replatform',
  REMAIN = 'Remain',
  RETAIN = 'Retain',
  DECOM = 'Decom',
  NO_DATA = 'No data',
  NOT_APPLICABLE = 'n/q',
}

export enum NorthStarTarget {
  ALREADY_AZURE = 'Already On Azure',
  AZURE = 'Azure',
  HYBRIDE = 'Hybride (Azure + Gen 2)',
  GEN2 = 'Gen 2',
  RETAIN_ON_PREM = 'Retain On Prem',
  NO_DATA = 'No data',
}

export const NorthStarTargetStatus = [
  NorthStarPath.ALREADY_AZURE,
  NorthStarPath.REDEPLOY,
  NorthStarPath.REFACTOR,
  NorthStarPath.RE_HOST,
  NorthStarPath.REPLATFORM,
  NorthStarPath.WILL_NOT_GO_AZURE,
];

export type NorthStar = {
  id: number;
  iAppliID: string;
  kearID: string | null;
  migrationStartDate: string | null;
  migrationEndDate: string | null;
  austinStartDate: string | null;
  austinEndDate: string | null;
  target: NorthStarTarget | null;
  path: NorthStarPath | null;
  updatedBy: string | null;
  comment: string | null;
  lastUpdate: string | null;
};

export type PatchNorthStarDTO = Pick<NorthStar, 'comment' | 'path'> & {
  kearID: string;
  readonly recordFrom: string;
  readonly recordTo: string;
  expectedDate: string | undefined;
  startDate: string | undefined;
  readonly enablers: Array<string> | null;
};

export const NorthStarActions = [
  NorthStarTarget.ALREADY_AZURE,
  NorthStarTarget.AZURE,
  NorthStarTarget.HYBRIDE,
  NorthStarTarget.GEN2,
  NorthStarTarget.RETAIN_ON_PREM,
].sort();

export const EnablersOptions: Array<IReferenceValue> = [
  {
    key: 'TECHNOLOGY - SQL Server: 2019 / 2022',
    name: 'SQL Server: 2019 / 2022',
  },
  {
    key: 'TECHNOLOGY - PostgreSQL',
    name: 'PostgreSQL',
  },
  {
    key: 'TECHNOLOGY - Oracle',
    name: 'Oracle',
  },
  {
    key: 'TECHNOLOGY - MongoDB',
    name: 'MongoDB',
  },
  {
    key: 'TECHNOLOGY - Sybase',
    name: 'Sybase',
  },
  {
    key: 'TECHNOLOGY - Couchbase',
    name: 'Couchbase',
  },
  {
    key: 'TECHNOLOGY - Casandra',
    name: 'Casandra',
  },
  {
    key: 'TECHNOLOGY - Informatica',
    name: 'Informatica',
  },
  {
    key: 'TECHNOLOGY - SSAS',
    name: 'SSAS',
  },
  {
    key: 'TECHNOLOGY - SSRS',
    name: 'SSRS',
  },
  {
    key: 'TECHNOLOGY - SSIS',
    name: 'SSIS',
  },
  {
    key: 'TECHNOLOGY - PowerBI',
    name: 'PowerBI',
  },
  {
    key: 'TECHNOLOGY - ELK',
    name: 'ELK',
  },
  {
    key: 'TECHNOLOGY - RabbitMQ',
    name: 'RabbitMQ',
  },
  {
    key: 'TECHNOLOGY - IBM MQ',
    name: 'IBM MQ',
  },
  {
    key: 'TECHNOLOGY - NATS',
    name: 'NATS',
  },
  {
    key: 'TECHNOLOGY - Autosys',
    name: 'Autosys',
  },
  {
    key: 'TECHNOLOGY - Airflow',
    name: 'Airflow',
  },
  {
    key: 'TECHNOLOGY - UC4',
    name: 'UC4',
  },
  {
    key: 'TECHNOLOGY - Robust SMTP',
    name: 'Robust SMTP',
  },
  {
    key: 'NETWORK - Protocol',
    name: 'Protocol',
  },
  {
    key: 'NETWORK - File Transfert',
    name: 'File Transfert',
  },
  {
    key: 'NETWORK - FTB / FTR',
    name: 'FTB / FTR',
  },
  {
    key: 'NETWORK - SFTP',
    name: 'SFTP',
  },
  {
    key: 'NETWORK - Access to Office 365',
    name: 'Access to Office 365',
  },
  {
    key: 'NETWORK - Access to Filesystem',
    name: 'Access to Filesystem',
  },
  {
    key: 'NETWORK - Access to LAN API',
    name: 'Access to LAN API',
  },
  {
    key: 'NETWORK - Access from/to user computer',
    name: 'Access from/to user computer',
  },
  {
    key: 'NETWORK - Connectivity to bloomberg / Symphony',
    name: 'Connectivity to bloomberg / Symphony',
  },
  {
    key: 'NETWORK - Connectivity to DB on premise',
    name: 'Connectivity to DB on premise',
  },
  {
    key: 'NETWORK - Connectivity to Messaging on premise',
    name: 'Connectivity to Messaging on premise',
  },
  {
    key: 'NETWORK - Connectivity to Scheduler on premise',
    name: 'Connectivity to Scheduler on premise',
  },
  {
    key: 'SECURITY - Access to AD',
    name: 'Access to AD',
  },
  {
    key: 'SECURITY - Data Encryption Policy',
    name: 'Data Encryption Policy',
  },
  {
    key: 'SECURITY - Backup Policy',
    name: 'Backup Policy',
  },
  {
    key: 'OBSOLESCENCE - OS not supported By Azure',
    name: 'OS not supported By Azure',
  },
  {
    key: 'OBSOLESCENCE - Middleware/Middleware Version not supported By Azure',
    name: 'Middleware/Middleware Version not supported By Azure',
  },
];
